var exports = {
  "Nr": "DiscoveryGuildCard.module__card___ZUJRWW",
  "L8": "DiscoveryGuildCard.module__cardButton___ZUJRWW",
  "vK": "DiscoveryGuildCard.module__banner___ZUJRWW",
  "_e": "DiscoveryGuildCard.module__bannerImage___ZUJRWW",
  "Dw": "DiscoveryGuildCard.module__bannerScrim___ZUJRWW",
  "Kk": "DiscoveryGuildCard.module__icon___ZUJRWW",
  "rf": "DiscoveryGuildCard.module__body___ZUJRWW",
  "$": "DiscoveryGuildCard.module__titleRow___ZUJRWW",
  "fh": "DiscoveryGuildCard.module__nameText___ZUJRWW",
  "h_": "DiscoveryGuildCard.module__description___ZUJRWW",
  "qr": "DiscoveryGuildCard.module__footer___ZUJRWW",
  "dJ": "DiscoveryGuildCard.module__stat___ZUJRWW",
  "gW": "DiscoveryGuildCard.module__statDot___ZUJRWW",
  "rR": "DiscoveryGuildCard.module__statDotOnline___ZUJRWW" + " " + "DiscoveryGuildCard.module__statDot___ZUJRWW",
  "rb": "DiscoveryGuildCard.module__statDotMembers___ZUJRWW" + " " + "DiscoveryGuildCard.module__statDot___ZUJRWW",
  "KA": "DiscoveryGuildCard.module__statText___ZUJRWW",
};

module.exports = exports;
